<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto" v-loading="loading" element-loading-text="加载中，请耐心等待。">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: 50px;">
              <div style="float: left;font-size: 14px">
                <span>&nbsp;关键词：</span>
                <el-input size="small" prefix-icon="el-icon-search" placeholder="输入姓名搜索" v-model="searchKeyword" style="width: 140px"></el-input>
                <span>&nbsp;性别：</span>
                <el-select v-fixZoom size="small" v-model="selectSex" filterable placeholder="请选择" :clearable="true" style="width:90px;" >
                  <el-option v-for="item in selectSexArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <span>&nbsp;频率：</span>
                <el-select v-fixZoom size="small" v-model="selectFrequency" filterable placeholder="请选择" :clearable="true" style="width:120px;" >
                  <el-option v-for="item in frequencys" :key="item.index" :label="item.frequency" :value="item.id"></el-option>
                </el-select>
                <span>&nbsp;项目：</span>
                <el-select v-fixZoom size="small" v-model="selectProject" filterable placeholder="请选择" :clearable="true" style="width:140px;" >
                  <el-option v-for="item in projects" :key="item.index" :label="item.projectname" :value="item.id"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" type="primary" plain @click="searchWord1()">查询</el-button>
              </div>
              <div style="float: right">
                <span>回访状态筛选：</span>
                <el-select v-fixZoom size="small" v-model="selectType" filterable placeholder="请选择" :clearable="false" style="width:140px;" @change="changeType">
                  <el-option v-for="item in selectTypeArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            <div style="max-height: calc(100% - 100px);overflow-y: auto">
              <el-table v-loading="tableloading" element-loading-text="加载中，请耐心等待。" :data="showTable" border highlight-current-row ref="singleTable">
                <el-table-column
                  type="index"
                  label="序号"
                  width="50"
                align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  min-width="60"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="50"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getSex(scope.row.sex)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="birthday"
                  label="出生日期"
                  min-width="85"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="电话号码"
                  min-width="85"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="orglevelname"
                  label="所属区域"
                  min-width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="h_address"
                  label="家庭地址"
                  min-width="90"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="服务频率"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getFrequencyName(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="所属项目"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getProjectName(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="项目备注"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getProjectRemark(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="timelist"
                  label="接听时间段"
                  min-width="90"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="circumstances"
                  label="特殊情况"
                  min-width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="回访记录"
                  min-width="150"
                  align="center">
                  <template slot-scope="scope">
                    {{getRemarkShow(scope.row.id, 1)}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="回访时间"
                  min-width="100"
                  align="center">
                  <template slot-scope="scope">
                    {{getRemarkShow(scope.row.id, 2)}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="生命体征"
                  min-width="70"
                  align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.is_dead === 0">在世</span>
                    <span v-if="scope.row.is_dead === 1">离世</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="110">
                  <template slot-scope="scope">
                    <el-button size="small" type="success" icon="el-icon-phone-outline" :disabled="!(!scope.row.buttondisable)" @click="callChange(scope.row)">呼叫</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="处理信息"  align="center" min-width="90">
                  <template slot-scope="scope">
                    <span>{{scope.row.handleuesrname}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="text-align: center;margin-top: 10px;height: 40px;">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="callPhoneShow" v-if="callPhoneShow" width="1250px" :show-close="true"
      :close-on-click-modal="false" center top="8vh" class="all-open">
      <call-phone-page v-model="callPhoneShow" :callPhoneRow="changeRow"></call-phone-page>
    </el-dialog>
  </div>
</template>

<script>
import treeData from '../treeData/treeData.vue'
import callPhonePage from './childComponents/callPhonePage'
import {queryfrequency, queryproject} from '../../api/serviceObject'
import {querypersoncalllistremark, queryoldpersonbyoidsanduncall, queryoldpersongeneraluncall, queryoldpersonspecialuncall, searcholdpersonwithnewtype} from '../../api/custormservice'
import {queryorgcommunity} from '../../api/community'

export default {
  name: 'customerService',
  components: {callPhonePage, treeData},
  data () {
    return {
      // 左边
      orgData: [],
      searchKeyword: '',
      // 右边
      selectTypeArr: [{id: 1, name: '全部关爱长者'}, {id: 2, name: '当月未关爱长者'}, {id: 3, name: '日常固定关爱长者'}, {id: 4, name: '特殊关爱关爱长者'}],
      selectType: 1,
      orgid: '',
      frequencys: [],
      projects: [],
      tableData: [],
      lastcallremark: [],
      showTable: [],
      tableloading: false,
      oids: [],
      selectSex: '',
      selectSexArr: [{id: 0, name: '女'}, {id: 1, name: '男'}],
      selectProject: '',
      selectFrequency: '',
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      callPhoneShow: false,
      changeRow: {
        orgcommunitys: [],
        projects: [],
        frequencys: [],
        orgData: [],
        row: {}
      }
    }
  },
  created () {
    this.golobleObject.updateTableC = this.getTableNew
    this.golobleObject.getCallInfo = this.changeShow
    this.orgid = this.$store.state.user.orgid
    this.getCommunityData()
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  watch: {
  },
  methods: {
    checkChange (obj) {
      if (obj.type === 'check') {
        this.oids = obj.orgids
        this.currentPage = 1
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.getFrequency()
        this.changeRow.orgData = obj.orgData
        this.orgData = obj.orgData
      }
    },
    // 所属小区
    getCommunityData () {
      queryorgcommunity().then(res => {
        this.changeRow.orgcommunitys = res.data.orgcommunitys
      }).catch(() => {})
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 查询频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.changeRow.frequencys = this.frequencys
        this.getProjects()
      }).catch(() => {
        this.loading = false
      })
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.orgid
      }
      queryproject(data).then(res => {
        this.getAllTableData()
        this.projects = res.data.projects
        this.changeRow.projects = this.projects
      }).catch(() => {
        this.loading = false
      })
    },
    // 回访状态筛选
    changeType () {
      this.currentPage = 1
      this.pageSize = 10
      this.getEndTable()
    },
    // 查询按钮
    searchWord1 () {
      this.currentPage = 1
      this.pageSize = 10
      // 全部查询
      this.selectType = 1
      this.getAllTableData()
    },
    // 右边 全部查询
    getAllTableData () {
      if (!this.loading) {
        this.tableloading = true
      }
      let data = {
        oids: this.oids,
        lessname: this.searchKeyword,
        sex: this.selectSex,
        frequency_id: this.selectFrequency,
        project_id: this.selectProject
      }
      if (data.sex === '') {
        data.sex = -1
      }
      if (data.frequency_id === '') {
        data.frequency_id = -1
      }
      if (data.project_id === '') {
        data.project_id = -1
      }
      searcholdpersonwithnewtype(data, this.currentPage, this.pageSize).then(res => {
        this.tableData = res.data.persons
        this.totalCells = res.data.cnt
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          arr.push(this.tableData[i].id)
        }
        this.getRemarkByPids(arr)
      }).catch(() => {
        this.loading = false
        this.tableloading = false
      })
    },
    // 右边 当月未关爱长者
    getNoCallPersonTable () {
      if (!this.loading) {
        this.tableloading = true
      }
      let data = {
        oids: this.oids,
        page: this.currentPage,
        size: this.pageSize
      }
      queryoldpersonbyoidsanduncall(data).then(res => {
        this.tableData = res.data.persons
        this.totalCells = res.data.cnt
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          arr.push(this.tableData[i].id)
        }
        this.getRemarkByPids(arr)
      }).catch(() => {
        this.tableloading = false
      })
    },
    // 右边 日常固定关爱长者
    getCallOftenPersonTable () {
      if (!this.loading) {
        this.tableloading = true
      }
      let data = {
        oids: this.oids,
        page: this.currentPage,
        size: this.pageSize
      }
      queryoldpersongeneraluncall(data).then(res => {
        this.tableData = res.data.persons
        this.totalCells = res.data.cnt
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          arr.push(this.tableData[i].id)
        }
        this.getRemarkByPids(arr)
      }).catch(() => {
        this.tableloading = false
      })
    },
    // 右边 特殊关爱长者
    getCallSpecialPersonTable () {
      if (!this.loading) {
        this.tableloading = true
      }
      let data = {
        oids: this.oids,
        page: this.currentPage,
        size: this.pageSize
      }
      queryoldpersonspecialuncall(data).then(res => {
        this.tableData = res.data.persons
        this.totalCells = res.data.cnt
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          arr.push(this.tableData[i].id)
        }
        this.getRemarkByPids(arr)
      }).catch(() => {
        this.tableloading = false
      })
    },
    // 回访记录
    getRemarkByPids (pids) {
      let data = {
        pids: pids
      }
      querypersoncalllistremark(data).then(res => {
        this.loading = false
        this.tableloading = false
        this.lastcallremark = res.data.lastcallremark
        this.changeShow()
      }).catch(() => {
        this.loading = false
        this.tableloading = false
      })
    },
    changeShow () {
      this.showTable = []
      const handle = this.store2.state.other.isCallArr
      // console.log('handle', handle)
      let handleIDList = []
      for (let i = 0; i < handle.length; i++) {
        const arr = handle[i]
        handleIDList.push(parseInt(arr.id))
      }
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        const callObj = tempList[i]
        callObj.buttondisable = false
        callObj.handleuesrname = ''
        if (handleIDList.indexOf(callObj.id) > -1) {
          for (let ii = 0; ii < handle.length; ii++) {
            const usernameObj = handle[ii]
            if (usernameObj.id === callObj.id) {
              callObj.buttondisable = true
              callObj.handleuesrname = usernameObj.name + '正在呼叫'
            } else {
              callObj.buttondisable = false
              callObj.handleuesrname = ''
            }
          }
        }
        this.tableData.push(callObj)
      }
      this.showTable = this.tableData
      console.log('endlist', this.tableData)
    },
    getEndTable () {
      if (this.selectType === 1) {
        this.getAllTableData()
      } else {
        this.searchKeyword = ''
        if (this.oids.length === 0) {
          this.$message({message: '回访状态筛选需选择组织。', type: 'warning'})
          return
        }
        if (this.selectType === 2) {
          // 当月未关爱长者
          this.getNoCallPersonTable()
        } else if (this.selectType === 3) {
          // 日常固定关爱长者
          this.getCallOftenPersonTable()
        } else {
          // 特殊关爱长者
          this.getCallSpecialPersonTable()
        }
      }
    },
    getRemarkShow (id, index) {
      let remark = ''
      let remarktime = ''
      for (let i = 0; i < this.lastcallremark.length; i++) {
        if (id === this.lastcallremark[i].pid) {
          remark = this.lastcallremark[i].remark
          remarktime = this.lastcallremark[i].remarktime
        }
      }
      if (index === 1) {
        return remark
      } else {
        return remarktime
      }
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getFrequencyName (row) {
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequencyid === this.frequencys[i].id) {
          return this.frequencys[i].frequency
        }
      }
    },
    getProjectName (row) {
      let projectname = ''
      if (row.projectids !== null && row.projectids !== '' && row.projectids.length > 0) {
        for (let i = 0; i < row.projectids.length; i++) {
          if (projectname === '') {
            projectname = this.getProject2(row.projectids[i])
          } else {
            projectname = projectname + ',' + this.getProject2(row.projectids[i])
          }
        }
      } else {
        for (let i = 0; i < this.projects.length; i++) {
          if (row.projectid === this.projects[i].id) {
            projectname = this.projects[i].projectname
          }
        }
      }
      return projectname
    },
    getProject2 (id) {
      let projectname = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (id === this.projects[i].id) {
          projectname = this.projects[i].projectname
        }
      }
      return projectname
    },
    getProjectRemark (row) {
      for (let i = 0; i < this.projects.length; i++) {
        if (row.projectid === this.projects[i].id) {
          return this.projects[i].remark
        }
      }
    },
    callChange (row) {
      this.changeRow.row = row
      this.callPhoneShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getEndTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getEndTable()
    },
    // 呼叫结束刷新
    getTableNew () {
      if (this.searchKeyword !== '') {
        this.getAllTableData()
      } else {
        if (this.selectType === 1) {
          this.getAllTableData()
        } else {
          if (this.oids.length === 0) {
            this.selectType = 1
            this.getAllTableData()
          } else {
            if (this.selectType === 2) {
              // 当月未关爱长者
              this.getNoCallPersonTable()
            } else if (this.selectType === 3) {
              // 日常固定关爱长者
              this.getCallOftenPersonTable()
            } else {
              // 特殊关爱长者
              this.getCallSpecialPersonTable()
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerservice/index.vue